@import "../../scss/vars";

.x-sign-offs {
  margin-bottom: 40px;

  .x-sign-off-row {
    padding: 12px;
    @include bg05;
    border-radius: 8px;
    margin-top: 10px;

    &.is-approved {
      border-left: 4px solid $mint;
    }
    &.is-rejected {
      border-left: 4px solid #e5484d;
    }
    &.is-ready {
      border-left: 4px solid $blue;
    }

    .x-sign-off-main {
      display: flex;
      align-items: center;
      gap: 14px;
      min-height: 50px;

      .x-sign-off-text {
        flex: 1;
        min-width: 0;
      }

      .x-sign-off-ready {
        display: flex;
        align-items: center;
        @include bg10;
        border-radius: 5px;
        height: 40px;
        padding: 6px 12px 6px 6px;
        white-space: nowrap;
      }
    }

    .x-sign-off-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      margin-top: 10px;
    }

    .x-sign-off-note {
      margin-top: 8px;
      padding: 8px 10px;
      border-radius: 6px;
      @include bg10;
      white-space: pre-wrap;
    }

    .x-sign-off-meta {
      margin-top: 8px;
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
    }

    textarea {
      width: 100%;
      min-height: 70px;
      margin-top: 8px;
    }
  }

  .x-sign-off-add {
    margin-top: 16px;
  }
}


.x-sign-off-view {
  padding: 24px 28px 60px;

  .x-sign-off-view-head {
    align-items: center;

    margin-bottom: 6px;
    display: block;

    h2 {
      margin-bottom: 10px;
    }
  }

  .x-sign-off-decide {
    margin-top: 24px;
    padding: 14px 16px;
    border-radius: 8px;
    @include bg05;

    textarea {
      width: 100%;
      min-height: 80px;
      margin-top: 8px;
    }

    .x-sign-off-decide-buttons {
      display: flex;
      gap: 10px;
      margin-top: 12px;
      flex-wrap: wrap;
    }
  }

  .x-sign-off-history {
    margin-top: 24px;

    li {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      padding: 6px 0;
      border-bottom: 1px solid rgba(128, 128, 128, 0.15);

      .x-sign-off-history-when {
        min-width: 170px;
      }
    }
  }
}

.x-sign-off-inbox {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  padding: 10px 6px 0;

  .x-sign-off-inbox-tabs {
    display: flex;
    flex-shrink: 0;
    gap: 8px;
    margin-bottom: 14px;

    .x-sign-off-inbox-tab {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  }

  .x-sign-off-inbox-list {
    flex: 1;
    min-height: 0;
    padding: 0 6px 20px 0;
  }

  .x-sign-off-inbox-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    @include bg05;
    margin-bottom: 8px;

    &:hover {
      @include bg10;
    }

    .x-sign-off-inbox-text {
      flex: 1;
      min-width: 0;
    }
  }

  .x-sign-off-inbox-more {
    margin-top: 10px;
    display: inline-block;
  }
}
